if (!window.Eurus.loadedScript.has('quantity-selector.js')) {
  window.Eurus.loadedScript.add('quantity-selector.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xQuantitySelector', (
        productId,
        sectionId,
        qtyRuleMin,
        qtyRuleMax,
        isQtyRule,
        currencyCodeEnable,
        moneyWithCurrency,
        moneyFormat,
        quantityPriceBreaks = [],
        cartQtyVariant = 0,
        isTrackedInventory = false,
        inventoryQuantity = 0
      ) => ({
        qty: qtyRuleMin,
        min: qtyRuleMin,
        max: qtyRuleMax,
        isQtyRule: isQtyRule,
        cartQtyVariant: Number(cartQtyVariant) || 0,
        isTrackedInventory: isTrackedInventory,
        inventoryQuantity: inventoryQuantity,
        errInventory: false,
        errIncrement: false,
        errMax: false,
        _variantListener: null,
        init() {
          // The buy-buttons quantity box is not re-rendered on variant change, so keep its
          // limits in sync with the newly selected variant from the section-rendering response.
          this._variantListener = (event) => this.syncVariantState(event.detail?.html);
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, this._variantListener);
        },
        destroy() {
          if (this._variantListener) {
            document.removeEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, this._variantListener);
          }
        },
        syncVariantState(html) {
          if (!html || typeof html.getElementById !== 'function') return;
          const holder = this.$root.closest('[id^="atc-quantity-"], [id^="quantity-selector-"]');
          if (!holder) return;
          const source = html.getElementById(holder.id)?.querySelector('[data-qty-state]');
          if (!source) return;
          let state;
          try {
            state = JSON.parse(source.getAttribute('data-qty-state'));
          } catch (e) {
            return;
          }
          this.min = state.min ?? this.min;
          this.max = state.max ?? null;
          this.isQtyRule = Boolean(state.isQtyRule);
          this.cartQtyVariant = Number(state.cartQtyVariant) || 0;
          this.isTrackedInventory = Boolean(state.isTrackedInventory);
          this.inventoryQuantity = Number(state.inventoryQuantity) || 0;
          this.errIncrement = false;
          this.errMax = false;
          this.errInventory = false;
        },
        remainingByRule() {
          if (this.max == null) return 0;
          return Math.max(Number(this.max) - this.cartQtyVariant, 0);
        },
        remainingByInventory() {
          return Math.max(Number(this.inventoryQuantity) - this.cartQtyVariant, 0);
        },
        initQtyChangeEvent(selector) {
          this.$nextTick(() => {
            this.qty = document.getElementById(selector)?.value;
            document.addEventListener(`eurus:product:quantity-changed-${sectionId}`, (e) => {
              this.qty = e.detail.quantity;
              this.updatePrice();
            })
          });
        },
        minus(value) {
          if (this.qty - value <= this.min) {
            this.qty = this.min;
          } else {
            this.qty = parseInt(this.qty);
            (this.qty == 1) ? this.qty = 1 : this.qty = Math.ceil((this.qty - value) / value) * value;
          }
          this.errIncrement = false;
          this.errMax = false;
          this.errInventory = false;
          this.updatePrice();
        },
        plus(value) {
          const step = value > 0 ? value : 1;
          if (this.max != null && Number(this.qty) + value >= (this.max - this.cartQtyVariant) && this.isQtyRule) {
            this.qty = parseInt(this.max - this.cartQtyVariant);
          } else if (Number(this.qty) + step >= (this.inventoryQuantity - this.cartQtyVariant) && this.isTrackedInventory) {
            this.qty = parseInt(Math.floor((this.inventoryQuantity - this.cartQtyVariant) / step) * step);
          } else {
            this.qty = parseInt(this.qty);
            this.qty = this.qty - this.qty % value + value;
          }
          this.errIncrement = false;
          this.errMax = false;
          this.errInventory = false;
          this.updatePrice();
        },
        invalid(el, qtyRuleIncrement) {
          const number = parseFloat(el.value);
          this.errIncrement = false;
          this.errMax = false;
          this.errInventory = false;
          if (!Number.isInteger(number) || number < 1) {
            this.qty = this.min;
            this.updatePrice();
          }
          if (this.max != null && number > (this.max - this.cartQtyVariant)) {
            this.errMax = true;
          } else if (number > (this.inventoryQuantity - this.cartQtyVariant) && this.isTrackedInventory) {
            this.errInventory = true;
          } else if (number % qtyRuleIncrement != 0) {
            this.errIncrement = true; 
          } else {
            this.updatePrice();
          }
        },
        updatePrice() {
          const productTemplate = document.getElementById(`x-product-template-${productId}-${sectionId}`);
          if (!productTemplate) return;
          const moneyFormatType = currencyCodeEnable ? moneyWithCurrency : moneyFormat;
          const formatMoney = (amount) => Alpine.store('xHelper').formatMoney(amount, moneyFormatType);
          const update = (selector, value) => {
            productTemplate.querySelectorAll(selector).forEach((el) => el.innerHTML = value);
          };
          const unitPrice = Number(productTemplate.querySelector('.target-price')?.innerHTML) || 0;
          const compareAtPrice = Number(productTemplate.querySelector('.target-compare-at-price')?.innerHTML) || 0;
          let currentPrice = unitPrice;
          for (let i = 0; i < quantityPriceBreaks.length; i++) {
            if ((Number(this.qty) + this.cartQtyVariant) >= quantityPriceBreaks[i].minimum_quantity) {
              currentPrice = quantityPriceBreaks[i].price;
            }
          }
          update('.add_to_cart_button .main-product-price .price', formatMoney(currentPrice * this.qty));
          update('.add_to_cart_button .main-product-price .price-sale', formatMoney(currentPrice * this.qty));
          update('.add_to_cart_button .main-product-price .price-compare', formatMoney(compareAtPrice * this.qty));
          if (quantityPriceBreaks.length > 0) {
            update('.add_to_cart_button .main-product-price .unit-price', formatMoney(currentPrice));
            update(`#price-${sectionId}-${productId}`, formatMoney(currentPrice));
          }
          document.dispatchEvent(new CustomEvent(`quantity:changed-${sectionId}`, {
            detail: {
              qty: this.qty
            }
          }));
        },
      }));
    })
  });
}    